import { z } from "zod";
import { photoRouletteReactionEmojiSchema } from "./game.js";

export const sendPhotoRouletteReactionSchema = z.object({
	emoji: photoRouletteReactionEmojiSchema,
});

export type SendPhotoRouletteReactionPayload = z.infer<typeof sendPhotoRouletteReactionSchema>;
